module.exports = __webpack_public_path__ + "img/small_big_heart.50b40318.svg";